export const MaxDisksPerController = 15;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/hosts/storage/vmware/StorageContainer.consts.js